import { render, staticRenderFns } from "./OrderSelect.vue?vue&type=template&id=54c9a774&scoped=true&"
import script from "./OrderSelect.vue?vue&type=script&lang=js&"
export * from "./OrderSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrderSelect.vue?vue&type=style&index=0&id=54c9a774&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c9a774",
  null
  
)

export default component.exports